<!-- start page title -->
<app-pagetitle
  title="Perfil"
  [breadcrumbItems]="breadCrumbItems"
></app-pagetitle>
<!-- end page title -->

<div class="row">
  <div class="col-12 col-md-12">
    <div class="card">
      <div class="card-body d-flex align-items-start mt-3 mt-sm-0">
        <div class="flex-shrink-0">
          <div
            class="avatar-xl me-3 d-flex align-items-center justify-content-center bg-primary text-white"
            style="
              width: 64px;
              height: 64px;
              border-radius: 50%;
              font-size: 24px;
            "
          >
            {{ defaultAvatarName }}
          </div>
        </div>
        <div class="">
          <p class="mb-1 fs-5">
            {{ currentUser.name }}
          </p>
          <p class="text-muted">{{ currentUser.email }}</p>
        </div>
      </div>
    </div>
    
  </div>

  <div class="col-12 col-md-5">

    <div class="card">
      <div class="card-body">
        <h5 class="mb-2">Alterar senha</h5>
        <ngb-alert [dismissible]="false" type="warning">
          Sua senha deve atender aos seguintes requisitos: mínimo de
          <strong>6 caracteres, letras maiúsculas e símbolos</strong>
          , exemplo:
          <strong>123456Aa!</strong>
        </ngb-alert>
        <form class="mt-3" [formGroup]="changePasswordForm">
          <div class="form-group">
            <label class="form-label">
              Senha atual
              <span class="text-danger">*</span>
            </label>
            <input
              type="password"
              class="form-control"
              formControlName="senhaAtual"
              [ngClass]="{
                'is-invalid':
                  changePasswordForm.controls.senhaAtual.errors &&
                  changePasswordForm.controls.senhaAtual.touched,
              }"
            />
            <div
              class="invalid-feedback"
              *ngIf="
                changePasswordForm.controls.senhaAtual.errors &&
                changePasswordForm.controls.senhaAtual.touched
              "
            >
              Senha atual é obrigatória.
            </div>
          </div>
          <div class="form-group">
            <label class="form-label">
              Nova senha
              <span class="text-danger">*</span>
            </label>
            <input
              type="password"
              class="form-control"
              formControlName="novaSenha"
              [ngClass]="{
                'is-invalid':
                  changePasswordForm.controls.novaSenha.errors &&
                  changePasswordForm.controls.novaSenha.touched,
              }"
            />
            <div
              *ngIf="
                changePasswordForm.controls.novaSenha.errors?.weakPassword &&
                changePasswordForm.controls.novaSenha.touched
              "
              class="invalid-feedback"
            >
              A nova senha deve ter pelo menos 6 caracteres, incluindo letras
              maiúsculas e símbolos.
            </div>
          </div>

          <div class="form-group">
            <label class="form-label">
              Confirme a nova senha
              <span class="text-danger">*</span>
            </label>
            <input
              type="password"
              class="form-control"
              formControlName="confirmarNovaSenha"
              [ngClass]="{
                'is-invalid': changePasswordForm.errors?.passwordsMismatch,
              }"
            />
            <div
              *ngIf="changePasswordForm.errors?.passwordsMismatch"
              class="invalid-feedback"
            >
              As senhas não conferem.
            </div>
          </div>

          <div class="mt-3">
            <button type="submit" class="btn btn-primary w-md">
              Alterar senha
            </button>
          </div>
        </form>
      </div>
    </div>



    <!-- <div class="card">
      <div class="card-body">
        <h5 class="mb-3">Mensagens</h5>
        <div class="d-flex flex-wrap gap-2">
          Voce tem
          <strong>3</strong>
          mensagens não lidas.
        </div>
      </div>
    </div> -->
  </div> 
</div>
